export default function PHP_strtr() {
  return (
    <div>
      <h1>PHP_strtr</h1>
    </div>
  );
}
